<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Почтовый индекс</div>
            <div class="dx-field-value">
                <ai-text-box :value="data.mail_index" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import AiTextBox from '@/components/ai-text-box.vue';

const data = inject('serverData');
</script>
